<template>
  <div id="app" :class="[
    {supportSticky, 'is-overflow': isOverFlow},
    {'isMd': $route.meta.isMd}
  ]" :style="{
    paddingTop: `${showHeader ? paddingTop : '0'}px`,
    paddingBottom: `${showHeader ? '16' : '0'}px`}">
    <!--    <com-watermark ></com-watermark>-->
    <div class="jp-delete-container"
         v-if="isShowDeleteTip && actTips">
      <i class="el-icon-warning"></i>
      <p class="jp-delete-tip-content" v-dompurify-html="actTips"></p>
    </div>
    <com-md-header ref="refHeader" v-if="$route.meta.isMd"></com-md-header>
    <com-header ref="refHeader" v-else-if="showHeader"></com-header>
    <!--面包屑导航-->
    <com-breadcrumb @changeBreadcrumb="changeBreadcrumb" :class="isFixedBread? 'fixed-breadcrumb': ''"></com-breadcrumb>
    <keep-alive>
      <router-view class="fd-main" v-if="$route.meta.keep"/>
    </keep-alive>
    <router-view class="fd-main" v-if="!$route.meta.keep"/>
    <el-backtop :right="12" :bottom="36" style="width: 44px; height: 44px;">
      <div class="btn-back-top">
        <img class="img-back-top" src="./assets/image/ic_backtop.png"/>
      </div>
    </el-backtop>
    <!-- 智能外呼  -->
    <new-case-call v-if="showCall"/>
    <!-- 下载 -->
    <com-download taskName="batchPackTask" v-if="batchPackTaskId && $route.path.indexOf('brt-ag') === -1"/>
    <com-download taskName="confirmationExportTask" v-if="taskType === 1 && confirmationExportTaskId && $route.path.indexOf('brt-ag') === -1" />
  </div>
</template>

<script>
import {addClass, removeClass, hasClass} from '@/assets/js/dom';
import {supportSticky, getUrlKey} from '@/assets/js/tool';
import {mapGetters, mapState} from 'vuex';
import __canvasWM from '@/assets/js/water-mark/canvas';
import dataTable from '@/assets/js/dataTable';
const {CALL_STATUS} = dataTable;
const defaultPaddingTop = 60;
export default {
  name: 'App',
  components: {
    NewCaseCall: () => import('./components/app/new-case-call'),
    ComMdHeader: () => import('@/components/common/com-md-header.vue'),
  },
  data() {
    return {
      loading: false,
      // app的padding-top值
      paddingTop: defaultPaddingTop,
      // 是不是火狐
      isFirefox: false,
      // 支持不支持position: sticky
      supportSticky: false,

      isFixedBread: false,
      // 当前坐席类型1:公用，2：专人转席,有呼入功能
      callSeatType: 2,
    };
  },
  created() {
    if (window.location.pathname === '/tj/mediation-cloud-chart') {
      return;
    }
    this.initSystem();
    setTimeout(() => {
      this.initSystem();
    }, 1500);
    this.init();
  },
  mounted() {
    // 设置灰度策略
    this.$store.dispatch('SetGrayTest');
  },
  watch: {
    '$route'() {
      const name = ['案件详情'];
      if (name.includes(this.$route.name)) {
        this.isFixedBread = true;
      } else {
        this.isFixedBread = false;
      }
    },
    // 检测机构变化，获取当前机构是专人专席还是公共模式。
    actId: {
      handler(n) {
        // 如果当前机构存在的话
        setTimeout(() => {
          if (n && this.$route.name !== '运营平台') {
            // 获取当前席位类型
            this.getCallSeatType();
          }
        }, 1000);
      },
      immediate: true
    },
    userData: {
      deep: true,
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (this.userData && this.userData.name) {
            const arr = this.userData.name.split('');
            const length = this.userData.name.length;
            let name = '';
            if (length > 2) {
              name = `${arr.shift()}*${arr.pop()}`;
            } else if (length === 2) {
              name = `*${arr[1]}`;
            } else {
              name = `${arr[0]}`;
            }
            __canvasWM({
              content: {
                name,
                id: `ID：${this.userData.uid}`
              }
            });
          }
        });
      }
    },
    // 超管平台水印
    brtUserInfo: {
      deep: true,
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (this.brtUserInfo && this.brtUserInfo.name) {
            const arr = this.brtUserInfo.name.split('');
            const length = this.brtUserInfo.name.length;
            let name = '';
            if (length > 2) {
              name = `${arr.shift()}*${arr.pop()}`;
            } else if (length === 2) {
              name = `*${arr[1]}`;
            } else {
              name = `${arr[0]}`;
            }
            __canvasWM({
              content: {
                name,
                id: `ID：${this.brtUserInfo.id}`
              }
            });
          }
        });
      }
    },
  },
  beforeDestroy() {
    if (this.isFirefox) {
      removeClass(document.body, 'isFirefox');
    }
  },
  computed: {
    // 当前角色列表
    ...mapGetters(['roleList', 'actTips']),
    ...mapState({
      // 是否运营端跳转过来的
      isAdminUser: state => state.user.isAdminUser,
      userData: state => state.user.userData,
      // 超管平台的用户
      brtUserInfo: state => state.brtManager.userInfo,
      actId: state => state.user.actId,
      // 开通功能
      openFuns: state => state.user.openFuns,
      // 打包任务
      batchPackTaskId: state => state.longTask.batchPack.id,
      confirmationExportTaskId: state => state.longTask.confirmationExport.id,
      taskType: state => state.longTask.taskType,
      openCall: state => state.caseCall.openCall,
      callStatus: state => state.caseCall.callStatus,
      destroyCall: state => state.caseCall.destroyCall,
      callType: state => state.caseCall.callType,
      taskId: state => state.caseCall.taskId,
      bindId: state => state.caseCall.bindId,
      batchId: state => state.caseCall.batchId,
      viewState: state => state.caseCall.viewState,
      seatInfo: state => state.caseCall.seatInfo,
    }),
    isOverFlow() {
      // 当前有外呼并且是大杯的时候页面滚动条不显示
      return this.showCall && this.callType && this.callType.toString() === '1' && this.viewState === 'big';
    },
    showHeader() {
      if (this.$route.name === '机构排名') {
        return false;
      }
      if (this.$route.name === '统计报表' && this.$route.query.from === 'brt') {
        return false;
      }
      // 需要判断一下url地址，如果只判断$route,会有问题
      const {pathname} = window.location;
      if ((/^\/tj\/brt-ag/).test(pathname)) {
        return false;
      }
      const {
        name, path
      } = this.$route;
      // 如果/brt-ag开头的路由地址，则表明是管理系统，不显示头部
      if ((/^\/brt-ag/).test(path)) {
        return false;
      }
      return !['video-ing', '信息验证配置', '文书编辑', '调解云图', 'brt-ag-admin'].includes(name);
    },
    // 是否含有调解员角色
    isHasMediator() {
      const result = this.roleList ? this.roleList.filter(item => item.name === '调解员') : null;
      return result && result.length > 0;
    },
    // 是否是代理人端
    isAgentRule() {
      // 获取system，兼容处理，可能this.$route.query.system没有值
      const system = getUrlKey('system', window.location.href);
      if (this.$route.query.system) {
        return this.$route.query.system.indexOf('brt') > -1;
      } else {
        return system.indexOf('brt') > -1;
      }
    },
    // 是否允许存在呼入组件
    isHasCallIn() {
      // 当前不是视频间、用户在当前机构下存在调解员角色、不是从运营平台跳转过来的、不是代理人端。并且当前是专人专席模式，并且当前开通了呼入功能。
      const result = !this.isAgentRule && this.$route.name &&
        !['video-ing', '调解云图', '机构排名'].includes(this.$route.name) &&
        this.isHasMediator && !this.isAdminUser &&
        (/^2$/).test(this.callSeatType) &&
        this.openFuns.includes('mdtorPhoneInCall');
      return result;
    },
    // 是否显示删除提示
    isShowDeleteTip() {
      // 跟需求和钟飞确认，只在首页展示。
      return !this.isAgentRule && this.$route.name && this.$route.name === 'home';
    },
    showCall() {
      const result = (this.openCall || !this.destroyCall) || this.isHasCallIn;
      return result;
    }
  },
  methods: {
    // 配置标题
    setDocTitle() {
      const style = getUrlKey('style', window.location.href);
      let system = getUrlKey('system', window.location.href);
      system = system || 'tj';
      const current_config = style ? window.system_config[style] : window.system_config[system];

      let systemDocTitle;
      if (current_config) {
        systemDocTitle = current_config.docTitle || '';
        const favicon = current_config.favicon || current_config.icon;
        this.setFavicon(favicon);
      }

      let projectDocTitle = '';
      if (window.project_config) {
        projectDocTitle = window.project_config.getConfig('docTitle');
      }

      document.title = systemDocTitle || projectDocTitle || '保融通调解';
    },
    setFavicon(favicon) {
      if (!favicon) {
        return;
      }
      // 获取已有的<link>元素
      const existingLink = document.querySelector('link[rel="icon"]');
      if (existingLink) {
        // 修改现有的<link>元素的href属性
        existingLink.href = favicon; // 替换为你的新图标文件路径
      } else {
        // 如果没有现有的<link>元素，创建一个新的
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = favicon; // 替换为你的图标文件路径
        link.type = 'image/x-icon'; // 可选
        document.head.appendChild(link);
      }
    },
    initSystem() {
      if (window.system_config) {
        const {
          system, actId, style
        } = this.$router.history.current.query;
        //  这个有用，虽然有报错，但是不影响，不要删。
        this.system = system || 'tj';
        const current_config = style ? window.system_config[style] : window.system_config[system];
        if (current_config) {
          this.config = current_config;
        } else {
          this.config = this.system == 'brt' ? {} : null;
        }
      } else {
        window.system_config = {};
      }
      console.log('system_config', this.config, window.system_config);
      if (this.$route.name !== '运营平台') {
        this.setDocTitle();
      }
    },
    // 初始化
    init() {
      this.$store.commit('SET_OPEN_CALL', {
        isOpen: this.openCall,
        callType: this.callType,
        taskId: this.taskId,
        bindId: this.bindId,
        batchId: this.batchId,
      });
      // 当前页面加载完成
      this.$store.commit('SET_PROJECT_LOAD_STATE', 'create');
      // 清空缓存
      // body增加class isFirefox
      const agent = navigator.userAgent.toLowerCase();
      this.isFirefox = agent.indexOf('firefox') > 0;
      if (hasClass(document.body, 'isFirefox')) {
        removeClass(document.body, 'isFirefox');
      }
      if (this.isFirefox) {
        addClass(document.body, 'isFirefox');
      } else {
        removeClass(document.body, 'isFirefox');
      }
      // app增加class supportSticky
      this.supportSticky = supportSticky();
      this.$store.dispatch('QueryTaskBatchPack');
      this.$store.dispatch('ConfirmationTaskGet').then((res) => {
        this.$comConfirmationUploadDialog.show({queryParams: {}});
      });


      this.$store.dispatch('Login')
        .then(() => {
          // URL 传入 id 时，优先同步当前机构到该 id，避免被默认机构覆盖
          const id = getUrlKey('id', window.location.href);
          const accountList = this.$store.state.user.accountList || [];
          const targetAccount = id
            ? accountList.find(item => item && item.actId && item.actId.toString() === id.toString())
            : null;
          if (targetAccount && targetAccount.actId !== this.actId) {
            this.$store.dispatch('ChangeOrgan', targetAccount);
          }
          // 获取当前开通功能和文书类型
          this.$store.dispatch('getMdOpenFuncs');
          // 代理人端不请求这个接口
          if (!this.isAgentRule) {
            // 获取文书签字权限
            this.$store.dispatch('GetWSQZPower');
            // 校验当前机构及所在机构树是否有“调解员”角色
            this.$store.dispatch('validMediatorFlagInActId');
            // URL 有 id 但该机构不存在时，回退为当前有效机构
            if (id && !targetAccount && this.actId) {
              window.location.href = this.updateUrlParam(window.location.href, 'id', this.actId);
            }
          }
          // 获取Code码
          this.$store.dispatch('GetCodeType',
            ['1005', '1018', '1019', '1020', '1021', '1026', '1027',
              '8010', '8011', '8012', '8018', '8019', '8021', '8025', '8026', '8027', '8028', '8029', '8031', '8033', '8035', '8040', '8042', '8043', '8044', '8045', '8046', '8047', '8049', '8050',
              '11150173', '11400022', '11401198', '11401845', '11400032', '11400000', '11401164', '11150173', '11150171', '11800011',
              '11800027', '11101033', 'GB0006', 'YZW11400022', 'YZW11400000', '7011', '38102']);
        })
        .catch(err => {
          console.log('AcceptInfoStatistics', err);
        });
    },
    updateUrlParam(url, key, value) {
      const urlObj = new URL(url);
      urlObj.searchParams.set(key, value);
      return urlObj.toString();
    },
    changeBreadcrumb() {
      this.$nextTick(() => {
        // 获取头部高度
        this.paddingTop = this.getHeaderHeight();
      });
    },
    // 获取头部高度
    getHeaderHeight() {
      this.$refs.refHeader ? this.$refs.refHeader.initSystem && this.$refs.refHeader.initSystem() : '';
      const headerEl = this.$refs.refHeader && this.$refs.refHeader.$el;
      if (headerEl) {
        return headerEl ? headerEl.getBoundingClientRect().height : defaultPaddingTop;
      } else {
        return defaultPaddingTop;
      }
    },
    // 获取当前席位类型
    getCallSeatType() {
      if (!this.actId) {
        return false;
      }
      const params = {tenantId: this.actId};
      if (this.$route.query.system === 'brt-ag') {
        return false;
      }
      this.$api.getCallSeatType(params)
        .then(res => {
          if ((/^200$/).test(res.code)) {
            this.callSeatType = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      this.$api.getSeatInfo(this.actId)
        .then(({
                 code, data
               }) => {
          if (code === 200 && data) {
            data.tenantType = data.type;
            this.$store.commit('SEAT_INFO', data);
          }
        });
    }
  }
};
</script>

<style lang="scss">
html, body {
  width: 100%;
  height: 100%;
}

#app {
  display: flex;
  flex-direction: column;
  padding-bottom: 16px;
  min-height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  &.isMd {
    background: url("~@/assets/image/bg-03.png") left center/ 100% no-repeat;
  }
}

.fd-main {
  position: relative;
  flex: 1;
}

.btn-back-top {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid rgba(238, 238, 238, 0.6);
  box-shadow: 0 6px 12px 0 rgba(0, 104, 182, 0.1);
  background: #fff;
  cursor: pointer;
}

.img-back-top {
  width: 26px;
  height: 26px;
}

.fixed-breadcrumb {
  position: fixed;
  right: 40px;
  left: 40px;
  z-index: 30;
  margin: 0;
  padding: 16px 0;
  padding-left: 0 !important;
  background: #eef0f3 !important;
}

.jp-delete-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 12px 40px 0;
  padding: 0 16px;
  height: 48px;
  color: #333;
  border-radius: 1px;
  border: 1px solid #c42f2c;
  background: rgba(196, 47, 44, 0.12);

  i {
    margin-right: 4px;
  }

  .jp-delete-tip-content {
    color: #333;
    font-size: 12px;

    span {
      color: #c42f2c;
    }
  }
}

.is-overflow {
  height: 100%;
  overflow: hidden;
}
</style>
